import { render } from "./TheCategoryList.vue?vue&type=template&id=15028a77&scoped=true&ts=true"
import script from "./TheCategoryList.vue?vue&type=script&lang=ts"
export * from "./TheCategoryList.vue?vue&type=script&lang=ts"

import "./TheCategoryList.vue?vue&type=style&index=0&id=15028a77&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15028a77"]])

export default __exports__